import GenericService from 'services/genericService';
import {
	replaceEsim,
	getSimDetails,
	sendQrEmail,
	addSimCard,
	deleteSimCard,
	replaceSimCard,
} from 'utils/api/queries/microApi';
import * as payloads from 'utils/api/payloads/microApi';

export class SimService extends GenericService {
	public static getSimDetails(phoneNumber: string, serialNo?: string | null) {
		return getSimDetails(phoneNumber, serialNo).call();
	}

	public static replaceEsim(data: payloads.EsimData) {
		return replaceEsim(data).call();
	}

	public static sendQrEmail(data: payloads.EsimQr) {
		return sendQrEmail(data).call();
	}

	public static addSimCard(simType: payloads.SimType, data: payloads.SimDtoRequest) {
		return addSimCard(simType, data).call();
	}

	public static deleteSimCard(simType: payloads.SimType, data: payloads.SimDtoRequest) {
		return deleteSimCard(simType, data).call();
	}

	public static replaceSimCard(simType: payloads.SimType, data: payloads.ReplaceSimRequest) {
		return replaceSimCard(simType, data).call();
	}
}
